
<p-card [style]="{ width: configStyle.width, height: configStyle.height, overflow: 'hidden', margin: '10px', backgroundColor: configStyle.backgroundColor, borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }">
    <ng-template #header>
        <ng-container *ngTemplateOutlet="Toolbar">
        </ng-container>
        <ng-container *ngTemplateOutlet="WidgetHeader">
        </ng-container>
    </ng-template>
    <ng-template #title>
        <ng-container *ngTemplateOutlet="MainTitle">
        </ng-container>
    </ng-template>
    <ng-template #subtitle>     
        <ng-container *ngTemplateOutlet="Content">
        </ng-container>
    </ng-template>
    <ng-template #footer>
        <ng-container *ngTemplateOutlet="Widgetfooter">
        </ng-container>
    </ng-template>
</p-card>
